Vendd.Scripts.load(function () {

    var isRecaptchaLoaded = isLoginSuccess = false, forms = [], loginFailedAttempts;

    var LoginForm = function () {
        var self = this;
        this.isRecaptchaInitialized = false;

        var $context, $loginForm, $forgotForm, $loginFormButton, $forgotFormButton,
            wrapper, loginForm, forgotForm, lf, ff, returnUrl;

        var useEmailAsLoginName;

        var captchaWidgetId, captchaId, $captchaElement, $captchaContainer, captchaEnabled, recaptchaCallback;

        this.initRecaptcha = function () {
            if (typeof loginFailedAttempts === "undefined") return;
            self.isRecaptchaInitialized = true;

            $captchaElement = $loginForm.find(".recaptcha-id-element");
            $captchaContainer = $loginForm.find('.recaptcha-container');
            captchaEnabled = false;

            captchaId = $captchaElement.attr('id');

            var htmlExists = $captchaElement.length > 0 ? true : false;

            if (!htmlExists || loginFailedAttempts < 3)
                return;

            if (htmlExists && loginFailedAttempts >= 3) {
                $captchaContainer.show();
            }

            var sitekey = $captchaElement.data("sitekey");
            if (sitekey) {
                captchaEnabled = true;
                captchaWidgetId = grecaptcha.render(captchaId, {
                    'sitekey': sitekey,
                    'callback': recaptchaCallback
                });
            }
        };

        this.initLoginForm = function (envelope) {
            $context = envelope.message.data.context;
            $wrapper = $('.x-login-form', $context);

            if ($wrapper.length < 1)
                return false;

            $loginForm = $('.login-form', $wrapper);
            $forgotForm = $('.forgot-form', $wrapper);

            $loginFormButton = $('.js-submit-button', $loginForm);
            $forgotFormButton = $('.js-submit-button', $forgotForm);

            useEmailAsLoginName = $loginForm.data("useemailasloginname").toString().toLowerCase() === 'true';

            wrapper = $wrapper.get(0);
            loginForm = $loginForm.get(0);


            var formData = {
                loginName: '',
                password: '',
                rememberMe: false,
                loginRedirectUrl: '',
                logoutRedirectUrl: '',
                reCaptchaCode: ""
            };
            var forgotFormData = { loginName: "" };


            loginForm.validateRecaptcha = function () {
                if (!captchaEnabled)
                    return true;

                formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

                var res = false;

                if (formData.reCaptchaCode) {
                    $captchaContainer.find('.recaptcha-required').removeClass('error');
                    res = true;
                }
                else {
                    $captchaContainer.find('.recaptcha-required').addClass('error');
                }

                return res;
            };

            loginForm.resetRecaptcha = function () {
                // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
                // If a verify attempt has been made with a particular token, it cannot be used again. 
                // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
                if (captchaEnabled)
                    grecaptcha.reset(captchaWidgetId);
            };

            loginForm.removeRecaptcha = function () {
                $captchaElement.remove();
            };

            recaptchaCallback = function () {
                loginForm.validateRecaptcha();
            };

            wrapper.loading = function (loading) {
                if (loading) {
                    $wrapper.addClass('x-loading');
                } else {
                    $wrapper.removeClass('x-loading');
                }
            };

            loginForm.onSuccess = function (envelope) {
                /**
                 * Return Codes:
                 *
                 * Login_OperationSuccesful
                 * Login_InvalidLoginOrPassword
                 * Login_LoginIsLocked
                 * Login_LoginIsNotEnabled
                 * Login_ValidationError
                 * Login_GenericError
                 */

                var usermodel = envelope.message.data.model;

                loginForm.reset();

                Cookies.set("ForceClearCartLocalStorage", 1, { samesite: 'Lax' });
                Cookies.set("ForceClearCompareLocalStorage", 1, { samesite: 'Lax' });
                Cookies.set("ForceClearWishlistLocalStorage", 1, { samesite: 'Lax' });
                if (LhApp.Context.MultipleWishlistsEnabled)
                    Vendd.UserWishlist.ClearClientModel();
                returnUrl = usermodel.LoginForm.LoginRedirectUrl;
                _logoutRedirectUrl = usermodel.LoginForm.LogoutRedirectUrl;


                if ($loginForm.data('redirect')) {
                    returnUrl = $loginForm.data('redirect');
                }

                var renderInline = (returnUrl && returnUrl === document.location.pathname);
                var iframe = $('#Vendd-InlineAdmin');
                if (iframe.length > 0) {
                    //wrapper.loading(false); this will be handled in CreateCookieForInlineAdmin handler

                    Vendd.MessageBus.publish(
                        Vendd.InlineAdmin, new Vendd.InlineAdmin.Messages.CreateCookieForInlineAdmin(renderInline, formData.loginName, formData.password, returnUrl)
                    );
                } else {
                    wrapper.loading(false);

                    if (returnUrl && returnUrl !== "") {
                        document.location.href = decodeURIComponent(returnUrl);
                    }
                    else {
                        document.location.href = document.location.href;
                    }
                }
            };

            loginForm.onFailure = function (envelope) {
                wrapper.loading(false);

                var response = envelope.message.data;

                if (response.code === 'Login_InvalidLoginOrPassword') {
                    $('.js-error', $loginForm).hide();
                    $('.js-validation-error', $loginForm).show();

                    $('input[name="password"]', $loginForm).val("");
                } else {
                    $('.js-validation-error', $loginForm).hide();
                    $('.js-error', $loginForm).show();

                    $('input[name="password"]', $loginForm).val("");
                };

                loginFailedAttempts++;

                if (!captchaEnabled)
                    self.initRecaptcha();
                else
                    loginForm.resetRecaptcha();
            };

            loginForm.CreateCookieForInlineAdminOnSuccess = function (envelope) {

                var model = envelope.message.data.model;
                returnUrl = model.redirectUrl;

                var loginURL = LhApp.Context.InLineAdminEndpoint + '/vendd/api/Security/Authenticate';

                $.ajax({
                    url: loginURL,
                    data: { "Username": model.username, "Password": model.password },
                    dataType: "json",
                    xhrFields: { withCredentials: true }
                }).done(function (data) {

                    wrapper.loading(false);
                    if (returnUrl) {
                        document.location = decodeURIComponent(returnUrl);

                    } else {
                        if (document.location.href.indexOf('/login/') > -1 || document.location.href.indexOf('/registration/') > -1) {
                            var baseUrl = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/';
                            document.location.href = baseUrl;
                        } else {
                            document.location.href = document.location.href;
                        }
                    }
                });
            }

            loginForm.CreateCookieForInlineAdminOnFailure = function (envelope) {
                var model = envelope.message.data.model;
                if (model.redirectUrl) {
                    returnUrl = model.redirectUrl;
                }

                if (returnUrl) {
                    document.location = decodeURIComponent(returnUrl);
                } else {
                    if (document.location.href.indexOf('/login/') > -1 || document.location.href.indexOf('/registration/') > -1) {
                        var baseUrl = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/';
                        document.location.href = baseUrl;
                    } else {
                        document.location.href = document.location.href;
                    }
                }
            }

            loginForm.vendd_submit = function () {
                loginForm.IsSubmitted = true;

                formData.loginName = $('input[name="username"]', $loginForm).val().replace(/\s+/g, '');
                formData.password = $('input[name="password"]', $loginForm).val();

                var val1 = loginForm.validateRecaptcha();
                var val2 = lf.validate();

                if (!(val1 && val2))
                    return false;

                wrapper.loading(true);

                var currentUrl = window.location.href;

                if (currentUrl.indexOf("/login/") > -1)
                    formData.loginRedirectUrl = $loginForm.data('redirect') || formData.loginRedirectUrl;
                else
                    formData.loginRedirectUrl = $loginForm.data('redirect') || currentUrl;

                formData.logoutRedirectUrl = $loginForm.data('logoutredirect') || formData.logoutRedirectUrl;

                var accessToken = getQueryStringValueByName("accessToken") || "";

                Vendd.MessageBus.publishAsync(loginForm,
                    new Vendd.User.Messages.Login(
                        formData.loginName,
                        formData.password,
                        formData.rememberMe,
                        formData.loginRedirectUrl,
                        formData.logoutRedirectUrl,
                        formData.reCaptchaCode,
                        accessToken,
                        {
                            isLoginForm: true
                        }
                    )
                );
            };

            loginForm.reset = function () {
                $('.js-error', $loginForm).hide();
                $('.js-validation', $loginForm).hide();

                $('input[name="username"]', $loginForm).val("");
                $('input[name="password"]', $loginForm).val("");

                lf.reset();
                loginForm.resetRecaptcha();
            };

            //event listeners couple 1(1). do not use for anything else. use a copy of event listeners if needed.
            Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, loginForm, function (envelope) {
                isLoginSuccess = true;
            });
            //event listeners couple 1(2).do not use for anything else. use a copy of event listeners if needed.
            Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, loginForm, function (envelope) {
                if (isLoginSuccess) {
                    isLoginSuccess = true;
                    if (loginForm.IsSubmitted)
                        loginForm.onSuccess(envelope);
                }
            });
            Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginFailure, loginForm, function (envelope) {
                if (loginForm.IsSubmitted)
                    loginForm.onFailure(envelope);
            });
            Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminSuccess, loginForm, function (envelope) {
                if (loginForm.IsSubmitted)
                    loginForm.CreateCookieForInlineAdminOnSuccess(envelope);
            });
            Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminFailure, loginForm, function (envelope) {
                if (loginForm.IsSubmitted)
                    loginForm.CreateCookieForInlineAdminOnFailure(envelope);
            });



            if ($forgotForm.length > 0) {
                forgotForm = $forgotForm.get(0);

                forgotForm.onSuccess = function (envelope) {
                    wrapper.loading(false);

                    /**
                     * Return Codes:
                     *
                     * ForgotPassword_OperationSuccesful
                     * ForgotPassword_ValidationError
                     * ForgotPassword_UserNotExists
                     * ForgotPassword_GenericError
                     */
                    var code = envelope.message.data.code;
                    if (code === 'ForgotPassword_OperationSuccesful') {
                        $('.js-error', $forgotForm).hide();
                        $('.js-validation-error', $forgotForm).hide();
                        $('.js-content', $forgotForm).hide();
                        $('.js-success', $forgotForm).show();
                    } else {
                        if (code === 'ForgotPassword_UserNotExists') {
                            $('.js-error', $forgotForm).hide();
                            $('.js-not-found', $forgotForm).show();
                            $('.js-success', $forgotForm).hide();
                        }
                        else {
                            $('.js-error', $forgotForm).show();
                            $('.js-not-found', $forgotForm).hide();
                            $('.js-success', $forgotForm).hide();
                        }
                    }
                };

                forgotForm.onFailure = function (envelope) {
                    wrapper.loading(false);

                    $('.js-validation-error', $forgotForm).hide();
                    $('.js-error', $forgotForm).show();
                };

                forgotForm.submit = function () {
                    wrapper.loading(true);

                    Vendd.MessageBus.publishAsync(forgotForm, new Vendd.User.Messages.ForgotPassword(forgotFormData));
                };

                forgotForm.reset = function () {
                    $('.js-error', $forgotForm).hide();
                    $('.js-validation', $forgotForm).hide();
                    $('.js-success', $forgotForm).hide();

                    $('.js-content', $forgotForm).show();

                    $('input[name="username"]', $forgotForm).val("");

                    ff.reset();
                };

                Vendd.MessageBus.subscribe(Vendd.User.Messages.ForgotPasswordSuccess, forgotForm, forgotForm.onSuccess);
                Vendd.MessageBus.subscribe(Vendd.User.Messages.ForgotPasswordFailure, forgotForm, forgotForm.onFailure);
            }

            var loginNameVal = {
                required: 'loginName-required'
            };
            if (useEmailAsLoginName)
                loginNameVal.isEmail = 'loginName-invalid';

            var valOpts = {
                username: loginNameVal,
                password: {
                    required: 'password-required'
                }
            };

            $loginForm.validationEngine(valOpts);
            lf = $loginForm.data('validationEngine');

            if ($forgotForm.length > 0) {
                $forgotForm.validationEngine({
                    loginName: loginNameVal
                });
                ff = $forgotForm.data('validationEngine');
            }

            //$loginForm.on('click', '.js-submit-button', function (e) {
            //    e.preventDefault();
            //    e.stopPropagation();

            //    formData.loginName = $('input[name="username"]', $loginForm).val();
            //    formData.password = $('input[name="password"]', $loginForm).val();

            //    var val1 = loginForm.validateRecaptcha();
            //    var val2 = lf.validate();

            //    if (val1 && val2)
            //        loginForm.vendd_submit();
            //});

            $loginForm.on('keyup', 'input[name]', function (e) {
                var $this = $(this);

                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    $loginFormButton.click();

                    return;
                }

                formData[$this.attr('name')] = $this.val();

                lf.validate($this.attr('name'));
            });

            if ($forgotForm.length > 0) {

                $forgotForm.on('click', '.js-submit-button', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    forgotFormData.loginName = $('input[name="loginName"]', $forgotForm).val();

                    if (ff.validate())
                        forgotForm.submit();
                });

                $forgotForm.on('keyup', 'input[name]', function (e) {
                    var $this = $(this);

                    if (e.keyCode === 13) {
                        e.preventDefault();
                        e.stopPropagation();

                        $forgotFormButton.click();

                        return;
                    };

                    forgotFormData[$this.attr('name')] = $this.val();

                    ff.validate($this.attr('name'));
                });
            }

            $wrapper.on('click', '.js-forgot-show', function (e) {
                e.preventDefault();

                loginForm.reset();

                $loginForm.hide();
                $(this).hide();
                $forgotForm.show();
            });

            $wrapper.on('click', '.js-forgot-hide', function (e) {
                e.preventDefault();

                forgotForm.reset();

                $forgotForm.hide();
                $('.js-forgot-show', $loginForm).show();
                $loginForm.show();
            });

            $wrapper.on('click', '.js-password-reveal', function (e) {
                e.preventDefault();
                if ($(this).hasClass('shown')) {
                    $(this).removeClass('shown').siblings('input').prop('type', 'password');
                } else {
                    $(this).addClass('shown').siblings('input').prop('type', 'text');
                }
            });

            return true;
        };
    };

    var checkInitRecaptcha = function () {
        if (isRecaptchaLoaded) {
            _.each(forms, function (formobj) {
                if (!formobj.isRecaptchaInitialized)
                    formobj.initRecaptcha();
            });
        }
    };

    function initSsoLoginForm($context) {
        var $wrapper = $('.x-login-form', $context);

        if (!$wrapper.length) {
            return false;
        }

        var $loginForm = $('.login-form', $wrapper);

        $loginForm.on('click', '.sso-login-button', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.SsoLogin());
        });
    }

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-login-form', function (envelope) {
        if (LhApp.Context.SsoEnabled) {
            initSsoLoginForm(envelope.message.data.context);

            return;
        }

        var form = new LoginForm();
        if (form.initLoginForm(envelope)) {
            forms.push(form);
            checkInitRecaptcha();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, 'login-forms', function () {
        isRecaptchaLoaded = true;
        checkInitRecaptcha();
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, 'login-forms', function (envelope) {
        loginFailedAttempts = envelope.message.data.ActionCounters ? envelope.message.data.ActionCounters.FailedLogin : 0;
    });

});

//πριν αλλάξετε κάτι δείτε αυτό VDCORE-1899
Vendd.LoginSubmit = function (form) {
    $loginForm = $(form).closest('.login-form');
    if ($loginForm.length < 0) return false;
    loginForm = $loginForm.get(0);
    loginForm.vendd_submit();
};
